"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var endpoint_1 = require("./endpoint");
var BaseHybrisRequest = /** @class */ (function () {
    function BaseHybrisRequest() {
        // tslint:disable-next-line:typedef
        this.clientId = 'aida';
        this.languageCode = 'de';
        this.endpoint = new endpoint_1.Endpoint(process.env.HYBRIS_USER, process.env.HYBRIS_PASS, process.env.HYBRIS_BASE_URL);
    }
    return BaseHybrisRequest;
}());
exports.BaseHybrisRequest = BaseHybrisRequest;
//# sourceMappingURL=base_hybris_request.js.map